import { toast } from "sonner";
import { CalendarClock, BookOpen, Headphones } from "lucide-react";
import PayPalCheckout from "@/components/PayPalCheckout";
import { completeReaderPass, errorDetail } from "@/lib/reader";

const PASS_PRODUCT = { id: "reader-pass", title: "Leckie E-Reader Pass — 40 days", price: 15 };

export default function PassOffer({ user, price, days, onPaid, renew = false }) {
  const handlePaid = async (orderId) => {
    try {
      const res = await completeReaderPass(orderId);
      toast.success(
        renew
          ? `Renewed — your pass now runs until ${new Date(res.expires_at).toLocaleDateString()}.`
          : `Payment received — your ${days}-day pass is active!`
      );
      onPaid();
    } catch (e) {
      toast.error(errorDetail(e));
    }
  };

  return (
    <div className="border border-primary-gold/30 bg-[#121212]/90 backdrop-blur p-8 sm:p-10" data-testid="reader-pass-offer">
      <p className="font-mono-ui text-[10px] uppercase tracking-[0.25em] text-primary-gold">
        {renew ? `Renew for another ${days} days` : `Signed in as ${user.name || user.email}`}
      </p>
      <div className="flex items-baseline gap-3 mt-4">
        <span className="font-serif-display text-6xl text-text-primary" data-testid="reader-pass-price">
          ${price.toFixed(2)}
        </span>
        <span className="text-soft font-mono-ui text-xs uppercase tracking-[0.18em]">one-off payment</span>
      </div>
      <ul className="mt-6 space-y-3 text-sm text-soft">
        <li className="flex gap-3"><BookOpen className="w-4 h-4 text-primary-gold shrink-0 mt-0.5" /> All four novels, on screen</li>
        <li className="flex gap-3"><Headphones className="w-4 h-4 text-primary-gold shrink-0 mt-0.5" /> Read aloud by a male or female narrator</li>
        <li className="flex gap-3"><CalendarClock className="w-4 h-4 text-primary-gold shrink-0 mt-0.5" /> {days} days of access, no subscription</li>
      </ul>
      <div className="mt-8">
        <PayPalCheckout product={PASS_PRODUCT} onPaid={handlePaid} />
      </div>
    </div>
  );
}
